import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { UmsService } from '../ums.service';
import { HttpErrorResponse } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { FacultyDialogBoxComponent } from "../faculty-dialog-box/faculty-dialog-box.component";
import { NgxSpinnerService } from 'ngx-spinner';
import { PageEvent } from '@angular/material/paginator';
import { Router } from '@angular/router';
@Component({
  selector: 'app-faculty-data',
  templateUrl: './faculty-data.component.html',
  styleUrls: ['./faculty-data.component.scss']
})
export class FacultyDataComponent implements OnInit {
  displayedColumns = ['FacultyCode', 'FcDesc'];
  FacultyForm: FormGroup;
  facultyList: any;
  FacultySearchForm;
  APIService: any;
  dialogRef: MatDialogRef<any>;
  pageSize = 10;
  pageSizeOptions: number[] = [5, 10, 20];
  currentPage = 1;
  totalItems = 0;
  sortedData
  SessionNo: any;
  setIntervalSearch: any;
  constructor(
    public umsService: UmsService,
    private dialog: MatDialog,
    private fb: FormBuilder,
    public router: Router,
    private spinner: NgxSpinnerService
  ) { this.APIService = environment.serviceUrl; }

  ngOnInit(): void {
    if(JSON.parse(sessionStorage.getItem("session")) == null){
      this.fetchSecretData();
    }
    else if(JSON.parse(sessionStorage.getItem("session")) != null){
      let sessionData = JSON.parse(sessionStorage.getItem("session"));
      this.SessionNo = sessionData.SnNo
    }
    window.scroll(0, 0);
    this.getFacultyData();
    this.FacultySearchForm = this.fb.group({
      FcCode: new FormControl(''),
      FilterType: new FormControl('LIKE'),
    });
  }

  fetchSecretData() {
    this.umsService.getSecretData().subscribe((res) => {
      this.SessionNo = res.projectPharam['SnNo']
      }
    );
  }

  keypress() {

    if(this.setIntervalSearch){
      clearTimeout(this.setIntervalSearch);
    }
    this.setIntervalSearch = setTimeout(()=>{
      this.facultyList = [];
      const payload = {};
      payload['PageSize'] = this.pageSize;
      if(this.FacultySearchForm.value['FcCode'] != ''){
        payload['FilterType'] = 'LIKE';
        payload['FcCode'] = this.FacultySearchForm.value['FcCode'];
        payload['PageNumber'] = 1;
      }
      else {
        payload['PageNumber'] = this.currentPage;
      }
      this.umsService.searchFaculty(payload).subscribe(res => {
        if(res.status){
          this.facultyList = res.data;
          this.totalItems = res.data[0].TotalRecords;
        }
        else{
          this.facultyList = []
          this.totalItems = 0;
        }
       
      }, (ERROR: HttpErrorResponse) => {
        this.facultyList = [];
      });
    },1000)
   
  }
  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    const newPageIndex = event.pageIndex + 1;
    this.currentPage = newPageIndex;
    this.getFacultyData();
  }
  getFacultyData() {
    this.spinner.show();
    const payload = {};
    payload['PageSize'] = this.pageSize;
    payload['PageNumber'] = this.currentPage;
    this.umsService.getFaculty(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        this.facultyList = res.data;
        this.totalItems = res.data[0].TotalRecords;
      } else {
        this.spinner.hide();
        this.totalItems = 0;
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.facultyList = [];
    });
  }

  addnewrecord() {
    const dialogRef = this.dialog.open(FacultyDialogBoxComponent, {
      width: '35%',
      data: { key: "New" },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getFacultyData();
      this.FacultySearchForm.controls['FcCode'].setValue('');
    });
  }
  editData(k) {
    const dialogRef = this.dialog.open(FacultyDialogBoxComponent, {
      width: '35%',
      data: { selected: k, key: "Edit" },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getFacultyData();
      this.FacultySearchForm.controls['FcCode'].setValue('');
    });
  }
  deleteData(k) {
    const dialogRef = this.dialog.open(FacultyDialogBoxComponent, {
      width: '35%',
      data: { selected: k, key: "Delete" },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getFacultyData();
      this.FacultySearchForm.controls['FcCode'].setValue('');
    });
  }

  Print(){
    let submitpayload = this.FacultySearchForm.value;
    let payload1 = {}
    payload1['SearchString'] = submitpayload['FcCode'],
    payload1['MenuName'] ='Master-Faculty';
    let jsonString = JSON.stringify(payload1)
    var filter: any;
    filter = {
      "LoginId": parseInt(sessionStorage.getItem('userId')) ? parseInt(sessionStorage.getItem('userId')) : 0,
      "RptCode": 106,
      "InstName": '',
      "InstNo": this.umsService.secretdata['ClubPartTrans'] ? this.umsService.secretdata['ClubPartTrans'] : 0,
      "ShId": '',
      "CgCode": '',
      "RollNo": '',
      "Cent": '',
      "TnCode": '',
      "EsId":  '',
      "CsNo": '',
      "PgBreak": '',
      "StrId": '',
      "StrCode": '',
      "RgNo": '',
      "UC": '',
      "Ledger": '',
      "RegnRoll": '',
      "DsCode": '',
      "CoCode": '',
      "SnNo": this.SessionNo,
      "Extra1": jsonString,
    }

    var payload: any;
    payload = filter;
    this.umsService.setData(JSON.stringify(payload));
    this.redirect('reports')
  }

  redirect(to): void {
    this.router.navigate([to]);
  }
}
